<div class="dd-app-footer" *ngIf="sharedData?.showFooter === true">
  <div class="dd-line"></div>
  <div fxLayout="column" class="dd-content-margin">
    <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="10" fxLayoutAlign="space-between center" class="dd-footer-margin">
      <div fxLayout="row" fxLayoutGap="10" fxLayoutAlign="start center" class="dd-footer-text-color">
        <div><a href="https://www.toyota.com/support/privacy-rights" download="" target="_blank" rel="noopener noreferrer" class="dd-black-text">Privacy Policy</a></div>
        <div class="dd-footer-menu-separator">|</div>
        <div><a href="https://www.toyota.com/support/legal-terms" download="" target="_blank" rel="noopener noreferrer" class="dd-black-text">Legal Terms</a></div>
      </div>
      <div class="dd-view-all-disc-text">
        <!-- [#] View All Disclaimers -->
      </div>
    </div>
    <div fxLayout="row">
      &nbsp;
    </div>
    <div fxLayout="row" fxLayoutGap="5" fxLayoutAlign="center center" class="dd-footer-copy-right-text">
      ©2018 Toyota Motor Sales, U.S.A., Inc. All information applies to U.S. vehicles only.
    </div>
    <div fxLayout="row">
      &nbsp;
    </div>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>